/* eslint-disable no-undef */
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  selectAuthenticate,
  hideSmsModal,
  authenticateOtp,
  authenticateVerify,
} from "../../../state/ducks/login";
import Countdown from "react-countdown";
import NumberFormat from "react-number-format";

class SmsVerify extends Component {
  state = {
    smsCode: "",
    platform: "web",
    token: "",
    timerExpired: false,
    resendEnabled: false,
  };

  componentDidMount() {
    this.createCaptchaToken();
    this.syncTimerState();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.login?.countDate !== prevProps.login?.countDate ||
      this.props.login?.controlSmsVerify !== prevProps.login?.controlSmsVerify ||
      this.props.login?.controlEpostaVerify !== prevProps.login?.controlEpostaVerify
    ) {
      this.setState({ smsCode: "" });
      this.syncTimerState();
    }
  }

  syncTimerState = () => {
    const { login } = this.props;
    if (!login?.countDate) {
      return;
    }

    const expired = login.countDate + 180000 < Date.now();
    this.setState({
      timerExpired: expired,
      resendEnabled: expired,
    });
  };

  handleClose = () => {
    this.props.hideSmsModal();
    this.setState({ smsCode: "", timerExpired: false, resendEnabled: false });
  };

  timerEnd = () => {
    this.setState({ timerExpired: true, resendEnabled: true });
  };

  timerStart = () => {
    this.syncTimerState();
  };

  reSendSmsCode = (verifyType) => {
    const postData = {
      username: this.props.login.username,
      password: this.props.login.password,
      platform: this.state.platform,
      token: this.state.token,
      verifyType,
    };
    this.props.authenticateOtp(postData);
    this.setState({ smsCode: "", timerExpired: false, resendEnabled: false });
    this.createCaptchaToken();
  };

  authenticateVerify = (event) => {
    event.preventDefault();
    const postData = {
      username: this.props.login.username,
      password: this.props.login.password,
      smsCode: this.state.smsCode,
      platform: this.state.platform,
      token: this.state.token,
    };
    this.props.authenticateVerify(postData);
    this.setState({ smsCode: "" });
    this.createCaptchaToken();
  };

  authenticateOtp = (event) => {
    event.preventDefault();
    const { login } = this.props;
    const postData = {
      username: login.username,
      password: login.password,
      platform: this.state.platform,
      token: this.state.token,
      verifyType: 2,
    };
    this.props.authenticateOtp(postData);
    this.setState({ smsCode: "", timerExpired: false, resendEnabled: false });
    this.createCaptchaToken();
  };

  createCaptchaToken() {
    const that = this;
    grecaptcha.ready(function () {
      grecaptcha
        .execute("6LeiYdwUAAAAAFsmN76CLhs9VADdnPT4OnzKWCFT", {
          action: "/Home",
        })
        .then((token) => {
          that.setState({ token });
        });
    });
  }

  renderVerifyForm(isEmail) {
    const { login } = this.props;
    const { timerExpired, resendEnabled } = this.state;
    const title = isEmail ? "E-posta Doğrulama" : "SMS Doğrulama";
    const subtitle = isEmail
      ? "E-posta adresinize gönderilen kodu girin."
      : "Telefonunuza gönderilen SMS kodunu girin.";
    const inputLabel = isEmail ? "E-posta Doğrulama Kodu" : "SMS Şifreniz";
    const inputPlaceholder = isEmail
      ? "E-posta doğrulama kodunu giriniz"
      : "SMS şifrenizi giriniz";

    return (
      <div className="t-loginPage-verify">
        <header className="t-loginPage-head t-loginPage-head--verify">
          <h1 className="t-loginPage-title">{title}</h1>
          <p className="t-loginPage-subtitle">{subtitle}</p>
        </header>

        {login?.response ? (
          <div className="t-loginPage-verifyMessage">{login.response}</div>
        ) : null}

        <form onSubmit={this.authenticateVerify} className="t-loginPage-form">
          <div className="t-loginPage-field">
            <label className="t-loginPage-label" htmlFor="loginSmsCode">
              {inputLabel}
            </label>
            <div className="t-resetPassword-inputWrap">
              <span className="t-resetPassword-inputIcon">
                <i className="t-icon-phonelink_lock" aria-hidden="true" />
              </span>
              <NumberFormat
                id="loginSmsCode"
                displayType="input"
                maxLength={6}
                className="smsdecimalnumber"
                placeholder={inputPlaceholder}
                value={this.state.smsCode}
                disabled={timerExpired}
                onChange={(e) => {
                  this.setState({ smsCode: e.target.value });
                }}
                required
                autoComplete="one-time-code"
              />
            </div>
          </div>

          <div className="t-loginPage-verifyTimer" aria-live="polite">
            <i className="t-icon-clock" aria-hidden="true" />
            <span>Kalan süre:</span>
            <Countdown
              key={login?.countDate}
              date={login?.countDate + 180000}
              renderer={(props) => (
                <strong>{Math.max(0, Math.ceil(props.total / 1000))} sn</strong>
              )}
              onStart={this.timerStart}
              onComplete={this.timerEnd}
            />
          </div>

          <div className="t-loginPage-verifyActions">
            <button
              type="button"
              className="t-loginPage-backBtn"
              onClick={this.handleClose}
            >
              <i className="t-icon-arrow-left2" aria-hidden="true" />
              Geri Dön
            </button>
            <button
              type="button"
              className="t-loginPage-verifyResend"
              disabled={!resendEnabled}
              onClick={() => this.reSendSmsCode(isEmail ? 2 : 1)}
            >
              <i className="t-icon-loop2" aria-hidden="true" />
              Tekrar Gönder
            </button>
            <button
              type="submit"
              className="t-loginPage-submit"
              disabled={timerExpired}
            >
              GİRİŞ
            </button>
          </div>
        </form>

        {!isEmail ? (
          <button type="button" className="t-loginPage-verifyAltLink" onClick={this.authenticateOtp}>
            Doğrulama kodunu alamadınız mı? <span>E-posta ile doğrulayın.</span>
          </button>
        ) : null}
      </div>
    );
  }

  render() {
    const { login } = this.props;

    if (login?.controlSmsVerify) {
      return this.renderVerifyForm(false);
    }

    if (login?.controlEpostaVerify) {
      return this.renderVerifyForm(true);
    }

    return null;
  }
}

const mapStateToProps = (state) => ({
  login: selectAuthenticate(state),
});

const mapDispatchToProps = (dispatch) => ({
  authenticateOtp: (postData) => dispatch(authenticateOtp(postData)),
  authenticateVerify: (postData) => dispatch(authenticateVerify(postData)),
  hideSmsModal: () => dispatch(hideSmsModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SmsVerify);
